<template>
    <v-row>
        <v-col cols="12" sm="6" md="4">
            <v-list>
                 <show-field :value="item.username" :label="$t('admin.inviraUser.labels.username')" icon="person"/>
            </v-list>
        </v-col>

        <v-col cols="12" sm="6" md="4">
            <v-list>
                 <show-field :value="item.email" :label="$t('admin.inviraUser.labels.email')" icon="email"/>
            </v-list>
        </v-col>

        <v-col cols="12" sm="6" md="4">
            <v-list>
                 <show-field :value="item.company ? item.company.razonSocial : '-'" :label="$t('admin.inviraUser.labels.company')" icon="business"/>
            </v-list>
        </v-col>

        <v-col cols="12" sm="6" md="4">
            <v-list>
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title>{{ $t('admin.inviraUser.labels.role') }}</v-list-item-title>
                        <v-list-item-subtitle>
                            <v-chip v-if="item.role" small class="mr-1">
                                {{ item.role.name }}
                            </v-chip>
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-col>

        <v-col cols="12" sm="6" md="4">
            <v-list>
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title>{{ $t('admin.inviraUser.labels.active') }}</v-list-item-title>
                        <v-list-item-subtitle>
                            <v-chip small :color="item.active ? 'success' : 'error'">
                                {{ item.active ? $t('common.active') : $t('common.inactive') }}
                            </v-chip>
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-col>

    </v-row>
</template>
<script>
    import {ShowField} from '@dracul/common-frontend'
     
    
    export default {
        name: 'InviraUserShowData',
        components: {ShowField},
        
        props: {
            item: {type: Object, required: true}
        }
    }
</script>

